const error = (state: any = 0, action: any) => {
  switch (action.type) {
    case 'SET_ERROR':
      return action.status;
    default:
      return state;
  }
};

export default error;
